"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generate = exports.format = exports.validate = void 0;
function digit(numbers) {
    var index = 2;
    var sum = __spread(numbers).reverse().reduce(function (buffer, number) {
        buffer += Number(number) * index;
        index = index === 9 ? 2 : index + 1;
        return buffer;
    }, 0);
    var mod = sum % 11;
    return mod < 2 ? 0 : 11 - mod;
}
/**
 * Validates a CNPJ
 * @param cnpj The CNPJ value to be validated
 */
function validate(cnpj) {
    // Remove period, slash and dash characters from CNPJ
    var cleaned = cnpj.toString().replace(/[\.\/\-]/g, '');
    if (
    // Must be defined
    !cleaned ||
        // Must have 14 characters
        cleaned.length !== 14 ||
        // Must be digits and not be sequential characters (e.g.: 11111111111111, etc)
        /^(\d)\1+$/.test(cleaned)) {
        return false;
    }
    var registration = cleaned.substr(0, 12);
    registration += digit(registration);
    registration += digit(registration);
    return registration.substr(-2) === cleaned.substr(-2);
}
exports.validate = validate;
/**
 * Formats a CNPJ value
 * @param cnpj The CNPJ to be formatted
 * @return The formatted CNPJ
 */
function format(cnpj) {
    return (cnpj
        .toString()
        // Remove non digit characters
        .replace(/[^\d]/g, '')
        // Apply formatting
        .replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5'));
}
exports.format = format;
/**
 * Generates a valid CNPJ
 * @return The generated CNPJ
 */
function generate() {
    var cnpj = '';
    var i = 12;
    while (i--) {
        cnpj += Math.floor(Math.random() * 9);
    }
    cnpj += digit(cnpj);
    cnpj += digit(cnpj);
    return format(cnpj);
}
exports.generate = generate;
